import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Layout } from '../menu.types';

@Component({
  selector: 'app-layout-toggle',
  imports: [TranslatePipe],
  template: `
    <button
      type="button"
      (click)="toggleLayout.emit()"
      [attr.aria-label]="
        (layout() === 'list' ? 'menu.layoutToGrid' : 'menu.layoutToList') | translate
      "
      class="qm-view-toggle rounded-xl border border-slate-100 bg-white p-2 text-slate-600 shadow-sm transition-transform active:scale-95"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        @if (layout() === 'list') {
          <rect x="3" y="3" width="7" height="7"></rect>
          <rect x="14" y="3" width="7" height="7"></rect>
          <rect x="14" y="14" width="7" height="7"></rect>
          <rect x="3" y="14" width="7" height="7"></rect>
        } @else {
          <line x1="8" y1="6" x2="21" y2="6"></line>
          <line x1="8" y1="12" x2="21" y2="12"></line>
          <line x1="8" y1="18" x2="21" y2="18"></line>
          <line x1="3" y1="6" x2="3.01" y2="6"></line>
          <line x1="3" y1="12" x2="3.01" y2="12"></line>
          <line x1="3" y1="18" x2="3.01" y2="18"></line>
        }
      </svg>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutToggle {
  layout = input.required<Layout>();
  toggleLayout = output<void>();
}
